const TRACKER_PARAM = 'tracker=pdp_combo_offer'

const HREF_FINDER_REGEX = /(href=")(.*?)(")/g

const getTrackerParam = (url: string, productId: number) => {
  const separator = url.includes('?') ? '&' : '?'
  return `${separator}${TRACKER_PARAM}&source_product_id=${productId}`
}

export const getTrackerAddedComboMessageOffer = (content: string, productId: number) =>
  content.replace(HREF_FINDER_REGEX, (_match, p1, p2, p3) => `${p1}${p2}${getTrackerParam(p2, productId)}${p3}`)
